import React from "react";
import Image from "next/image";
const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL || "";

interface Block {
  title: string;
  description: string;
  description_two: string;
  image: {
    data: {
      attributes: {
        url: string;
      };
    };
  };
}
interface Props {
  block: Block;
}
const Mission: React.FC<Props> = ({ block }) => {
  const imageUrl = block?.image?.data?.attributes?.url;
  return (
    <>
      <section className="relative z-[0] overflow-hidden py-[56px] lg:py-[80px] xl:py-[100px] bg-white before:-z-10">
        <div className="container">
          <div className="grid grid-cols-1 xl:grid-cols-[calc(25%_-_15px)_calc(75%_-_15px)] md:grid-cols-[calc(40%_-_15px)_calc(60%_-_15px)] gap-[30px]">
            <div>
              <Image
                src={
                  imageUrl
                    ? baseUrl + imageUrl
                    : "/images/leadership/mind-bg.png"
                }
                alt="Mission Image"
                width={285}
                height={460}
                className="object-cover  h-[360px] mx-auto md:h-[460px]"
              />
            </div>
            <div>
              <h2 className="font-bold text-heading-1 text-primary-text md:mb-[24px] mb-[16px] md:text-left text-center">
                {block?.title}
              </h2>
              <h6 className="text-heading-6 font-regular text-primary-text mb-[24px] md:text-left text-center">
                {block?.description}
              </h6>
              <h6 className="text-heading-6 font-regular text-primary-text mb-[24px] md:text-left text-center">
                {block?.description_two}
              </h6>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Mission;
